import type { IconData } from '@stacksjs/iconify-core'

export const wifi: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M27.963 38a3.999 3.999 0 1 1-7.998 0a3.999 3.999 0 1 1 7.998 0\"/><path d=\"M4.2 17.1c-.7-1.226-.46-2.786.657-3.65C9.683 9.723 16.064 7 24 7c7.937 0 14.318 2.722 19.144 6.45c1.117.864 1.357 2.425.656 3.65l-.982 1.719c-.94 1.645-3.148 2.008-4.704.928C34.316 17.112 29.494 15 24 15c-5.493 0-10.316 2.112-14.113 4.747c-1.557 1.08-3.765.717-4.704-.928zm8.214 11.02c-.815-1.223-.642-2.88.542-3.75C15.768 22.306 19.173 21 24 21s8.233 1.306 11.044 3.37c1.185.87 1.358 2.527.543 3.75l-.954 1.43c-.855 1.284-2.668 1.49-3.998.708c-1.756-1.033-4.059-1.902-6.635-1.902s-4.878.87-6.634 1.902c-1.33.782-3.143.576-3.998-.707z\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default wifi
